import { DataType } from '@/util/index'

const PAYMENT_SCHEDULE = {
  section: {
    name: 'payment-schedule',
    caption: 'PAYMENT SCHEDULE'
  },
  sectionFields: [
    { label: '#', template: '{index}', fieldKey: 'index' },
    { label: 'DATE', template: '{transactionDate}', fieldKey: 'transactionDate' },
    { label: 'MODE', template: '{transactionMode}', fieldKey: 'transactionMode', options: { transactionMode: DataType.TransactionMode } },
    { label: 'TYPE', template: '{transactionType}', fieldKey: 'type', options: { transactionType: DataType.TransactionTypeOptions } },
    { label: 'REQUEST TYPE', template: '{changeType}', fieldKey: 'requestType', options: { changeType: DataType.ChangeType } },
    { label: 'AMOUNT', template: '{amount}', fieldKey: 'amount', format: 'currency' },
    { label: 'PRINCIPAL', template: '{principal}', fieldKey: 'principal', format: 'currency' },
    { label: 'FINANCE CHARGE', template: '{interest}', fieldKey: 'financeFee', format: 'currency' },
    { label: 'UNPAID FINANCE', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' }
  ]
}
const PAYMENT_AMOUNT = {
  LEFT: [
    { label: 'PRINCIPAL', template: '{principal}', fieldKey: 'principal', format: 'currency' },
    { label: 'FINANCE CHARGE', template: '{interest}', fieldKey: 'interest', format: 'currency' },
    { label: 'UNPAID FINANCE', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' }
  ],
  RIGHT: { label: 'TOTAL', template: '{amount}', fieldKey: 'amount', format: 'currency' }
}
export { PAYMENT_SCHEDULE, PAYMENT_AMOUNT }
